<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Education Level"
      text="Edit Education Level"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localEducationLevel.name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="localEducationLevel.level"
                :rules="[rules.required,rules.min]"
                min="1"
                type="number"
                label="Level"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="localEducationLevel.description"
                outlined
                label="Description"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          class="px-10"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="px-10 white--text"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      educationLevel: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localEducationLevel: null,
        rules: {
          required: value => !!value || 'Required.',     
          min: value => value >= 1 || 'Minimum number is 1',      
        },  
      }
    },

    watch: {
      dialog: function (value) {
        if (!value) return
        this.localEducationLevel = { ...this.educationLevel }
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.hrisEducationLevels().update(this.educationLevel.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.progressing = false
                  this.dialog = false
                }
              })
              .catch((err) => {
                if (err.response.status === 500) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }

                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: 'Duplicate level', 
                  })
                }
                
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          name: this.localEducationLevel.name,
          description: this.localEducationLevel.description,
          level: this.localEducationLevel.level,
        }
      },
    },
  }
</script>
